document.body.insertAdjacentHTML("beforeend", `
  <div id="lb-video-tour-modal" style="display:none; position:fixed; inset:0; background:rgba(0,0,0,0.75); z-index:999999; align-items:center; justify-content:center; padding:20px;">
    <div style="background:#fff; width:90%; max-width:600px; border-radius:12px; overflow:hidden; box-shadow:0 10px 30px rgba(0,0,0,0.35); position:relative;">
      <div style="display:flex; align-items:center; justify-content:space-between; padding:14px 18px; background:#111; color:#fff; font-family:Arial,sans-serif;">
        <div style="font-size:20px; font-weight:700;">Video Tour Guide</div>
        <button id="lb-video-tour-close" style="background:none; border:none; color:#fff; font-size:28px; cursor:pointer; line-height:1;">&times;</button>
      </div>

      <div style="padding:18px; font-family:Arial,sans-serif; color:#222;">
        <p style="margin:0 0 14px; font-size:15px; line-height:1.6;">
          Watch this quick video to understand the design process more easily. You can then continue with the interactive guided tour.
        </p>

        <div style="position:relative; width:100%; padding-top:56.25%; background:#000; border-radius:8px; overflow:hidden;">
          <iframe
            id="lb-video-tour-iframe"
            src=""
            title="Lucky Bags Video Tour Guide"
            style="position:absolute; inset:0; width:100%; height:100%; border:0;"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen>
          </iframe>
        </div>

        <div style="display:flex; gap:10px; justify-content:flex-end; margin-top:16px;">
          <button id="lb-video-tour-skip" style="padding:10px 16px; border:1px solid #ccc; background:#fff; color:#222; border-radius:8px; cursor:pointer; font-size:14px;">
            Skip Video
          </button>
          <button id="lb-video-tour-start" style="padding:10px 16px; border:none; background:#19b600; color:#fff; border-radius:8px; cursor:pointer; font-size:14px; font-weight:700;">
            Continue Guided Tour
          </button>
        </div>
      </div>
    </div>
  </div>
`);

(function () {
  var CLICKABLE = "button,a,[role='button'],[tabindex],li,span,div";
  var tourInstance = null;

  function normalize(value) {
    return (value || "").replace(/\s+/g, " ").trim().toLowerCase();
  }

  function isVisible(el) {
    if (!el || !el.getBoundingClientRect) return false;

    var rect = el.getBoundingClientRect();
    if (rect.width < 8 || rect.height < 8) return false;

    var style = window.getComputedStyle(el);
    return (
      style.display !== "none" &&
      style.visibility !== "hidden" &&
      style.opacity !== "0"
    );
  }

  function area(el) {
    var rect = el.getBoundingClientRect();
    return rect.width * rect.height;
  }

  function pickSmallest(list) {
    if (!list || !list.length) return null;

    list.sort(function (a, b) {
      return area(a) - area(b);
    });

    return list[0];
  }

  function realClick(el) {
    if (!el) return false;

    try {
      el.scrollIntoView({ block: "center", inline: "center" });
    } catch (e) {}

    try {
      el.dispatchEvent(new MouseEvent("mousedown", { bubbles: true, cancelable: true, view: window }));
      el.dispatchEvent(new MouseEvent("mouseup", { bubbles: true, cancelable: true, view: window }));
      el.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true, view: window }));
      if (typeof el.click === "function") el.click();
    } catch (e) {}

    return true;
  }

  function getRoot() {
    return document.querySelector(
      ".fpd-container, .fpd-product-designer, #fpd-product-designer, .fpd-modal, .fpd-dialog"
    );
  }

  function findByLabel(root, labels) {
    if (!root) return null;

    var all = root.querySelectorAll(CLICKABLE);

    for (var l = 0; l < labels.length; l++) {
      var wanted = normalize(labels[l]);
      var exact = [];

      for (var i = 0; i < all.length; i++) {
        var el = all[i];
        if (!isVisible(el)) continue;

        var text = normalize(el.innerText || el.textContent);
        if (text === wanted) exact.push(el);
      }

      if (exact.length) return pickSmallest(exact);
    }

    for (var l2 = 0; l2 < labels.length; l2++) {
      var wanted2 = normalize(labels[l2]);
      var fuzzy = [];

      for (var k = 0; k < all.length; k++) {
        var el2 = all[k];
        if (!isVisible(el2)) continue;

        var text2 = normalize(el2.innerText || el2.textContent);
        if (text2.indexOf(wanted2) !== -1) fuzzy.push(el2);
      }

      if (fuzzy.length) return pickSmallest(fuzzy);
    }

    return null;
  }

  function getLeftRailItem(el) {
    var node = el;

    while (node && node !== document.body) {
      var rect = node.getBoundingClientRect();

      if (
        isVisible(node) &&
        rect.left < 130 &&
        rect.width <= 130 &&
        rect.height >= 40 &&
        rect.top > 70
      ) {
        return node;
      }

      node = node.parentElement;
    }

    return el;
  }

  function findLeftRailTab(root, label) {
    if (!root) return null;

    var wanted = normalize(label);
    var all = root.querySelectorAll(CLICKABLE);
    var matches = [];

    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (!isVisible(el)) continue;

      var text = normalize(el.innerText || el.textContent);
      if (text !== wanted) continue;

      var railItem = getLeftRailItem(el);
      if (!railItem) continue;

      var rect = railItem.getBoundingClientRect();
      if (rect.left < 130 && rect.top > 70) {
        matches.push(railItem);
      }
    }

    return pickSmallest(matches);
  }

  function findLayerLabelElement(label) {
    var root = getRoot();
    if (!root) return null;

    var wanted = normalize(label);
    var nodes = root.querySelectorAll("div,span,p,strong,b,a,button,li");
    var matches = [];

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!isVisible(el)) continue;

      var rect = el.getBoundingClientRect();

      // Restrict to the left layers panel text area only.
      if (rect.left < 120 || rect.left > 360) continue;
      if (rect.top < 80 || rect.top > window.innerHeight - 80) continue;
      if (rect.width < 40 || rect.height < 18) continue;

      var text = normalize(el.innerText || el.textContent);
      if (!text) continue;

      if (text === wanted || text.indexOf(wanted) === 0) {
        matches.push(el);
      }
    }

    return pickSmallest(matches);
  }

  function getLayerCardFromLabelEl(el, label) {
    var wanted = normalize(label);
    var node = el;

    while (node && node !== document.body) {
      var rect = node.getBoundingClientRect();
      var text = normalize(node.innerText || node.textContent);

      if (
        isVisible(node) &&
        rect.left > 100 &&
        rect.left < 260 &&
        rect.width > 260 &&
        rect.width < 520 &&
        rect.height > 60 &&
        rect.height < 220 &&
        text.indexOf(wanted) !== -1
      ) {
        return node;
      }

      node = node.parentElement;
    }

    return null;
  }

  function findLayerCardByLabel(label) {
    var labelEl = findLayerLabelElement(label);
    if (!labelEl) return null;
    return getLayerCardFromLabelEl(labelEl, label);
  }

  function findLayerDetails() {
    return findLayerCardByLabel("Design Layer Controls");
  }

  function moveNext() {
    if (tourInstance && typeof tourInstance.moveNext === "function") {
      tourInstance.moveNext();
    }
  }

  function movePrevious() {
    if (tourInstance && typeof tourInstance.movePrevious === "function") {
      tourInstance.movePrevious();
    }
  }

  function openLayersAndNext() {
    var root = getRoot();
    if (!root) return;

    var layersTab = findLeftRailTab(root, "Layers");
    realClick(layersTab);

    var start = Date.now();
    var timer = setInterval(function () {
      if (
        findLayerDetails()
      ) {
        clearInterval(timer);
        setTimeout(function () {
          moveNext();
        }, 100);
        return;
      }

      if (Date.now() - start > 1200) {
        clearInterval(timer);
        moveNext();
      }
    }, 60);
  }

  function reopenLayersAndPrevious() {
    var root = getRoot();
    if (!root) return;

    var layersTab = findLeftRailTab(root, "Layers");
    realClick(layersTab);

    setTimeout(function () {
      movePrevious();
    }, 250);
  }

  function openSavedDesignsAndNext() {
    var root = getRoot();
    if (!root) return;

    var savedTab =
      findLeftRailTab(root, "Saved Designs") ||
      findByLabel(root, ["Saved Designs"]);

    realClick(savedTab);

    setTimeout(function () {
      moveNext();
    }, 300);
  }

  function buildSteps(root) {
    var fileEl = findByLabel(root, ["File"]);
    var logosEl = findLeftRailTab(root, "LB Logos") || findByLabel(root, ["LB Logos"]);
    var uploadEl = findByLabel(root, [
      "Upload your Background and Logo",
      "Upload your Background",
      "Upload"
    ]);
    var addTextEl = findByLabel(root, ["Add your own Text", "Add Text"]);
    var layersEl = findLeftRailTab(root, "Layers");
    var savedEl = findLeftRailTab(root, "Saved Designs") || findByLabel(root, ["Saved Designs"]);
    var zoomEl = findByLabel(root, ["Zoom"]);
    var rulerEl = findByLabel(root, ["Toggle Ruler", "Ruler"]);
    var doneEl = findByLabel(root, ["Done"]);

    return [
      {
        popover: {
          title: "Welcome to the Design Studio",
          description: "Welcome! This tour will show you how to create your custom design - starting with a reminder that trademarked logos aren’t allowed. From here, you’ll learn to add logos, upload images, recolor each piece, add text, and finish your product!"
        }
      },
      {
        element: fileEl,
        popover: {
          title: "File & Design Options",
          description: "This menu provides additional tools for your design. You can view design information, preview your final look, download or print your design, and reset the canvas if you want to start over.",
          side: "bottom",
          align: "start"
        }
      },
      {
        element: logosEl,
        popover: {
          title: "Choose Your Lucky Bags Logo",
          description: "In this step, you’ll select one of three official Lucky Bags logos. Once you choose your logo, you’ll be able to customize its colors to match your unique design vision.",
          side: "right",
          align: "start"
        }
      },
      {
        element: uploadEl,
        popover: {
          title: "Upload Backgrounds, Images & Icons",
          description: "Create the perfect background for your design. You can upload your own image - whether from a file or AI or simply choose a solid color with the color picker. Be as creative as you want, but remember: trademarked logos are not allowed.",
          side: "right",
          align: "start"
        }
      },
      {
        element: addTextEl,
        popover: {
          title: "Add & Customize Text",
          description: "With text, you have tons of options. You can customize fill and stroke colors, add drop shadows, change fonts, adjust sizes, spacing, and positioning. You can even transform, curve, or fine-tune every detail - making your text as unique as your final design.",
          side: "right",
          align: "start"
        }
      },
      {
        element: layersEl,
        popover: {
          title: "Manage Your Design Layers",
          description: "Control the layers of your design here. Reorder elements to bring them forward or send them backward so each piece - logo, text, or background - sits exactly where you want it.",
          side: "right",
          align: "start",
          onNextClick: function () {
            openLayersAndNext();
          }
        }
      },
      {
      element: function () {
        return findLayerDetails();
      },
      popover: {
        title: "Design Layer Controls",
        description: "Customize this design object. Move, resize, rotate, or reposition it on the canvas. Use the color boxes to open the palette and change fill, border, accent colors, and shadow effects.",
        side: "right",
        align: "start",
        onPrevClick: function () {
          reopenLayersAndPrevious();
        }
      }
    },
      {
        element: savedEl,
        popover: {
          title: "Saved Designs",
          description: "Access your previously saved designs here. You can reopen a design to continue editing, make adjustments, or reuse it for future orders without starting from scratch.",
          side: "right",
          align: "start",
          onPrevClick: function () {
            reopenLayersAndPrevious();
          }
        }
      },
      {
        element: zoomEl,
        popover: {
          title: "Zoom Controls",
          description: "Use the zoom tools to get a closer look at your design or zoom out to view the full layout. This helps you fine - tune small details and ensure everything is perfectly positioned.",
          side: "bottom",
          align: "start"
        }
      },
      {
        element: rulerEl,
        popover: {
          title: "Ruler & Alignment Guides",
          description: "Toggle the ruler to display measurement guides on the canvas. These guides help you align logos, text, and images precisely for a clean and professional design.",
          side: "bottom",
          align: "start"
        }
      },
      {
        element: doneEl,
        popover: {
          title: "Finish Your Design",
          description: "When you're happy with your design, click Done to finalize your customization. You’ll then be able to review your design and continue to the next step to add your product to the cart.",
          side: "left",
          align: "start"
        }
      }
    ];
  }

  function openVideoTourPopup() {
    var modal = document.getElementById("lb-video-tour-modal");
    var iframe = document.getElementById("lb-video-tour-iframe");
    if (!modal || !iframe) {
      startTour();
      return;
    }

    iframe.src = "https://www.youtube.com/embed/_bq3wTlUWUo?autoplay=1";
    modal.style.display = "flex";
  }

  function closeVideoTourPopup() {
    var modal = document.getElementById("lb-video-tour-modal");
    var iframe = document.getElementById("lb-video-tour-iframe");
    if (iframe) iframe.src = "";
    if (modal) modal.style.display = "none";
  }

  function initVideoTourPopup() {
    var closeBtn = document.getElementById("lb-video-tour-close");
    var skipBtn = document.getElementById("lb-video-tour-skip");
    var startBtn = document.getElementById("lb-video-tour-start");
    var modal = document.getElementById("lb-video-tour-modal");

    if (closeBtn) {
      closeBtn.addEventListener("click", function () {
        closeVideoTourPopup();
      });
    }

    if (skipBtn) {
      skipBtn.addEventListener("click", function () {
        closeVideoTourPopup();
        startTour();
      });
    }

    if (startBtn) {
      startBtn.addEventListener("click", function () {
        closeVideoTourPopup();
        startTour();
      });
    }

    if (modal) {
      modal.addEventListener("click", function (e) {
        if (e.target === modal) {
          closeVideoTourPopup();
        }
      });
    }
  }

  function startTour() {
    var root = getRoot();
    if (!root) return;

    var makeDriver =
      window.driver &&
      window.driver.js &&
      typeof window.driver.js.driver === "function"
        ? window.driver.js.driver
        : null;

    if (!makeDriver) return;

    if (tourInstance && typeof tourInstance.destroy === "function") {
      try {
        tourInstance.destroy();
      } catch (e) {}
    }

    tourInstance = makeDriver({
      showProgress: true,
      animate: true,
      allowClose: true,
      nextBtnText: "Next",
      prevBtnText: "Back",
      doneBtnText: "Finish",
      stagePadding: 8,
      steps: buildSteps(root)
    });

    tourInstance.drive();
  }

  document.addEventListener(
  "click",
  function (e) {
    var trigger =
      e.target && e.target.closest
        ? e.target.closest('[data-action="guided-tour"]')
        : null;

    if (!trigger) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    openVideoTourPopup();
  },
  true
);

  initVideoTourPopup();
})();